import { useState } from "react";
import { ComponentLoadingSpinner } from "..";
import { IActionButton } from "../../interfaces";
import { useNavigate } from "react-router-dom";
import { gaButtonClassNameMap, gaIconColorMap, gaIconMap } from "../../utils/gaiaUtils";

export const GaActionButton = ({ onclick, callback, onErrorCallback, payload, dataTestId, text, title, buttonClassName, iconClassName, disabled }: IActionButton) => {
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleClick = () => {
        setShowLoading(true);

        var promise = onclick(payload);
        promise ? promise.then((data: any) => {
            setShowLoading(false);
            callback && callback(data);
        }).catch((error: any) => {
            if (error?.status === 404)
                navigate("/error/404");
            else
                onErrorCallback ? onErrorCallback(error) : navigate("/error/500");
        }) :
            setShowLoading(false);
    }

    
    const IconComponent = iconClassName ? gaIconMap[iconClassName] : null;
    const gaButtonClassName = gaButtonClassNameMap[buttonClassName ?? "btn"] || "ga-button ga-button--secondary";

   
    return (
        <>
            {showLoading && <button className={`${gaButtonClassName} ar-ga-action-button-mr`} disabled><ComponentLoadingSpinner size="xs"/>{text}</button>}
            {!showLoading &&
                <button className={`${gaButtonClassName} ar-ga-action-button-mr`} onClick={handleClick} data-testid={dataTestId} disabled={disabled} title={title}>
                    {IconComponent && <IconComponent size={16} color={gaIconColorMap[iconClassName]} />}
                    {text}
                </button>
            }
        </>
    )
}